"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryRunnerAdapter = void 0;
const address_1 = require("../address");
const smartContractQuery_1 = require("../smartContractQuery");
class QueryRunnerAdapter {
    constructor(options) {
        this.networkProvider = options.networkProvider;
    }
    async runQuery(query) {
        const adaptedQuery = {
            address: address_1.Address.fromBech32(query.contract),
            caller: query.caller ? address_1.Address.fromBech32(query.caller) : undefined,
            func: query.function,
            value: query.value,
            getEncodedArguments: () => query.arguments.map((arg) => Buffer.from(arg).toString("hex")),
        };
        const adaptedQueryResponse = await this.networkProvider.queryContract(adaptedQuery);
        return new smartContractQuery_1.SmartContractQueryResponse({
            function: query.function,
            returnCode: adaptedQueryResponse.returnCode.toString(),
            returnMessage: adaptedQueryResponse.returnMessage,
            returnDataParts: adaptedQueryResponse.getReturnDataParts(),
        });
    }
}
exports.QueryRunnerAdapter = QueryRunnerAdapter;
//# sourceMappingURL=queryRunnerAdapter.js.map